import { CommonModule, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { ActivatedRoute } from '@angular/router';
import { TourChannel, TourStatus } from '../../enums/tour-statuses.enum';
import { MessageService } from 'primeng/api';
import { TourService } from '../followups/tour.service';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from '../../core/shared/shared.module';
import { CalendarModule } from 'primeng/calendar';
import { usPhoneValidator } from '../../core/shared/validators/us-phone.validator';
import { PhoneUtils } from '../../core/shared/utils/phone.utils';
import moment from 'moment';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { PropertyService } from '../properties/service/property.service';
import { TimezoneDateRangeUtil } from '../../core/shared/utils/timezone-date-range.util';
import { take } from 'rxjs';

@Component({
  selector: 'app-properties',
  standalone: true,
  imports: [TableModule,
    CommonModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    DialogModule,
    ToastModule,
    SharedModule,
    CalendarModule,
    ReactiveFormsModule,
    NgxMaskDirective
  ],
  templateUrl: './schedule-tour.component.html',
  styleUrls: ['./schedule-tour.component.scss'],
  providers: [MessageService, provideNgxMask()]
})
export class ScheduleTourComponent {
  readonly modelUnitLabel = 'Model Unit';
  scheduleForm!: FormGroup;
  tours: any[] = [];
  loading = true;
  error = '';
  timeZone: string = '';
  searchTerm = '';
  cancelTourDialog: boolean = false;
  selectedTour: any = null;
  isConfirmLoading: boolean = false;
  rescheduleTourDialog: boolean = false;
  dateTimeDialog: boolean = false;
  selectedDate: Date | null = null;
  selectedTime: string | null = null;
  step: number = 1;
  minDate = new Date();
  availableTimes: string[] = [];
  isTimeLoading: boolean = false;
  sorting: any = {
    field: '',
    order: 1
  };
  totalRecords: number = 0;
  rowsPerPage: number = 10;
  currentPage: number = 0;
  visitorName: string = '';
  visitorEmail: string = '';
  visitorPhone: string = '';
  a1: string = '';
  defaultMonth: string = '';
  propertyId: string = '';
  planName: string = '';
  phoneNumber: string = '';
  propertyName: string = '';
  tourCreated: boolean = false;
  notUsed: boolean = true;
  propertyTimezone: string = 'UTC'; 
  landlordId: string = '';
  token: string = ''; 
  ptoken: string = ''; 
  unitOptions: any[] = [];
  isModelUnit = false;
  message: string = 'Thank You!<br/>Your tour has been successfully scheduled.<br/>You will be contacted shortly once it is approved.';
  showContent: boolean = false;
  userInfo: any = null;
  maxDate!: Date;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private tourService: TourService,
    private propertyService: PropertyService
  ) {}

  // ngOnInit() {
  //   this.route.queryParamMap.subscribe(params => {
  //     this.visitorName = params.get('name') || '';
  //     this.visitorEmail = params.get('email') || '';
  //     this.a1 = params.get('a1') || '';
  //     this.token = params.get('token') || '';

  //     // Split a1 into its parts
  //     const parts = this.a1.split('|').map(p => p.trim());
  //     this.propertyName = parts[0] || '';
  //     this.planName = parts[1] || '';
  //     let phone = parts[2] || '';
  //     if (phone && phone.startsWith('1')) {
  //       phone = phone.substring(1); // cut off 1
  //     } else if (phone.startsWith('+1')) {
  //       phone = phone.substring(2); // cut off +1
  //     }
      
  //     this.visitorPhone = phone;
  //     this.propertyId = parts[3] || '';
  //     if(this.token){
  //       this.propertyId = this.token;
  //     }

  //     this.scheduleForm.patchValue({
  //       visitorName: this.visitorName,
  //       visitorEmail: this.visitorEmail,
  //       visitorPhone: this.visitorPhone,
  //       planName: this.planName
  //     });

  //     this.defaultMonth = params.get('month') || '';
  //     const dateParam = params.get('date');
  //     this.selectedDate = dateParam ? new Date(dateParam) : new Date();
      
  //     this.loadUnits();

  //   });

  //   this.step = 1; // Step 1: select date
  // }

  ngOnInit() {
      
    this.scheduleForm = this.fb.group({
      visitorName: ['', Validators.required],
      visitorEmail: ['', [Validators.required, Validators.email]],
      visitorPhone: ['', [Validators.required, usPhoneValidator]],
      planName: ['', Validators.required],
    });
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token') || '';
      this.ptoken = params.get('ptoken') || '';
      if (!this.token && !this.ptoken) {
        this.message = "No secure token provided.";
        this.step = 0; // hide form
        this.tourCreated = true;
        setTimeout(() => this.showContent = true, 50);
        return;
      }

      if(this.ptoken){
        this.propertyId = this.ptoken;
        
        // Load units from backend
        this.loadUnits();
        this.getProperty(this.propertyId);
        setTimeout(() => this.showContent = true, 50);
      }

      // ✅ Call backend to fetch link info
      if(!this.ptoken){
        this.tourService.validateSecureToken(this.token).subscribe({
          next: (res) => {
            console.log('res', res)
            if (res.status !== "pending") {
              this.tourCreated = true;
              this.step = 0;
              this.message = "This link has already been used.";
              setTimeout(() => this.showContent = true, 50);
              return;
            }

            // ✅ Populate component fields from backend payload
            const payload = res.payload || {};
            this.visitorName = payload.name || '';
            this.visitorEmail = payload.email || '';
            let phone = payload.phone || '';
            // Remove +1 if present
            if (phone && phone.startsWith('1')) {
              phone = phone.substring(1); // cut off 1
            } else if (phone.startsWith('+1')) {
              phone = phone.substring(2); // cut off +1
            }
            this.visitorPhone = phone;

            this.propertyName = payload.property_name || '';
            this.propertyId = payload.property_id || '';
            this.planName = payload.unit_name || '';

            // Patch form values
            this.scheduleForm.patchValue({
              visitorName: decodeURIComponent(this.visitorName),
              visitorEmail: decodeURIComponent(this.visitorEmail),
              visitorPhone: decodeURIComponent(this.visitorPhone),
              planName: decodeURIComponent(this.planName)
            });

            // Optional: handle default month/date if backend provides
            if (payload.default_month) {
              this.defaultMonth = payload.default_month;
            }
            if (payload.default_date) {
              this.selectedDate = new Date(payload.default_date);
            } else {
              this.selectedDate = new Date();
            }

            // Step 1: show form
            this.step = 1;
            this.tourCreated = false;

            // Load units from backend
            this.loadUnits();
            this.getProperty(this.propertyId);
            setTimeout(() => this.showContent = true, 50);
          },
          error: (err) => {
            this.step = 0;
            this.tourCreated = true;
            this.message = "Invalid link.";
            setTimeout(() => this.showContent = true, 50);
          }
        });
      }
    });
    
    // ✅ Touch all fields to run validators
    this.scheduleForm.markAllAsTouched();
  }

  getProperty(propertyId: string): void {
    if (!propertyId) return;

    this.propertyService.getPropertyById(propertyId).pipe(take(1)).subscribe((property) => {

      this.userInfo = property;
      this.isModelUnit = !!property?.modelUnit;
      if (this.isModelUnit) {
        this.unitOptions = [{ label: this.modelUnitLabel, value: this.modelUnitLabel }];
      }
      this.applyModelUnitState();

      const { maxDate } = TimezoneDateRangeUtil.todayToNextDays(property?.timezone, 29);

      this.maxDate = maxDate;
    });
  }

  // ✅ Simple search filter
  get filteredTours() {
    if (!this.searchTerm.trim()) return this.tours;
    const term = this.searchTerm.toLowerCase();
    return this.tours.filter(tour =>
      (tour.property_name?.toLowerCase().includes(term)) ||
      (tour.tour_id?.toString().includes(term)) ||
      (tour.customer_email?.toLowerCase().includes(term))
    );
  }

  closeDialogue(): void {
    this.cancelTourDialog = false;
    this.rescheduleTourDialog = false;
    this.selectedTour = null;
    this.dateTimeDialog = false;
    this.isConfirmLoading = false;
    this.selectedDate = null;
    this.selectedTime = null;
  }

  confirmCancelTour(followup: any): void {
    this.cancelTourDialog = true;
    this.isConfirmLoading = false;
    this.selectedTour = followup;
  }

  tourStatus(followUp: any): { text: string; class: string } {
    const status = followUp?.status;
    const tourStatus = followUp?.tourStatus;

    // if status is Active or Pending, prefer that
    if ((status === TourStatus.ACTIVE && tourStatus == TourStatus.IN_PROGRESS) || (status === TourStatus.PENDING && tourStatus !== TourStatus.CANCELLED)) {
      return this.formatStatus(status);
    }

    // otherwise, use tourStatus (completed, cancelled, etc.)
    const appendText = (status === TourStatus.PENDING && tourStatus == TourStatus.CANCELLED) ? 'Auto ' : '';
    return this.formatStatus(tourStatus, appendText);
  }

  formatStatus(value: string, appendText: string = ''): { text: string; class: string } {
    if (!value) return { text: '', class: '' };
    const formatted = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    return {
        text: appendText ? appendText + formatted : formatted,
        class: formatted
    };
  }

  confirmReschedulelTour(followup: any): void {
    this.rescheduleTourDialog = true;
    this.isConfirmLoading = false;
    this.selectedTour = followup;
  }

  rescheduleTourConfirm() {
    this.rescheduleTourDialog = false;
    this.step = 1;
    // this.selectedDate = null;
    this.selectedTime = null;
    this.dateTimeDialog = true;
    this.isConfirmLoading = false;
  }

  goToTimeSelection() {
    if (!this.selectedDate) {
      return;
    }

    this.step = 2;
    this.isTimeLoading = true;

    const scheduleDate = formatDate(this.selectedDate, 'MM/dd/yyyy', 'en-US');

    // Convert selected date to weekday
    const weekday = this.selectedDate.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

    this.tourService.getPropertyTimeSlot(this.propertyId, weekday, scheduleDate).subscribe({
      next: (res: any) => {
        this.isTimeLoading = false;
        this.propertyTimezone = res.timeZone;
        this.landlordId = res.landlordId;
        const utcSlots = res.slots || [];
        this.availableTimes = utcSlots.map((utcTime: string) => {
          return this.convertUtcToPropertyTimezone(utcTime, this.propertyTimezone);
        });
        
        if (!this.availableTimes.length) {
          let message = 'No time slots available on this date.';
          if(res?.blackoutDate){
            message = 'Tours are not available on this date.';
          }
          this.messageService.add({
            severity: 'warn',
            summary: 'No Slots',
            detail: message
          });
        }
      },
      error: () => {
        this.isTimeLoading = false;
        this.availableTimes = [];
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load available time slots'
        });
      }
    });
  }

  convertUtcToPropertyTimezone(utcTime: string, targetTimezone: string): string {
    const utcMoment = moment.utc(utcTime, ['HH:mm', moment.ISO_8601]);
    const localMoment = utcMoment.clone(); //.tz(targetTimezone);
    return localMoment.format('hh:mm A'); // e.g. 02:00 PM
  }

  convertToAmPm(time24: string): string {
    if (!time24) return '';
    const [hoursStr, minutes] = time24.split(':');
    let hours = parseInt(hoursStr, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return `${hours}:${minutes} ${ampm}`;
  }

  convertTo24Hour(time12: string): string {
    if (!time12) return '';
    
    const [time, modifier] = time12.split(' '); // "5:30 PM" => ["5:30", "PM"]
    let [hoursStr, minutes] = time.split(':');
    let hours = parseInt(hoursStr, 10);
    if (modifier.toUpperCase() === 'PM' && hours < 12) {
      hours += 12;
    }
    if (modifier.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }
    const hoursPadded = hours.toString().padStart(2, '0');
    return `${hoursPadded}:${minutes}`;
  }

  scheduleTour(): void {
    if (this.isConfirmLoading) return;
    this.isConfirmLoading = true;

    if (!this.selectedDate) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a date.' });
      this.isConfirmLoading = false;
      return;
    }

    if (!this.selectedTime) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a time.' });
      this.isConfirmLoading = false;
      return;
    }
    
    // Disable form to prevent changes while submitting
    this.scheduleForm.disable();


    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneLong = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'long',
    }).formatToParts(new Date()).find((part) => part.type === 'timeZoneName')?.value;

    const scheduleDate = formatDate(this.selectedDate, 'MM/dd/yyyy', 'en-US');
    const scheduleDateISO = formatDate(this.selectedDate, 'yyyy-MM-dd', 'en-US');
    const planned_date = scheduleDateISO + ' ' + this.convertTo24Hour(this.selectedTime)
    this.visitorName = this.scheduleForm.get('visitorName')?.value;
    this.visitorEmail = this.scheduleForm.get('visitorEmail')?.value;
    this.visitorPhone = this.scheduleForm.get('visitorPhone')?.value;
    this.planName = this.isModelUnit ? this.modelUnitLabel : this.scheduleForm.get('planName')?.value;
    
    const tourPayload = {
      customer_name: this.visitorName,
      customer_email: this.visitorEmail,
      phone_number: PhoneUtils.toE164(this.visitorPhone),
      plan_name: this.planName,
      date: scheduleDate,
      property_id: this.propertyId,
      property_name: this.propertyName,
      status: TourStatus.PENDING,
      time: this.selectedTime,
      planned_date: planned_date,
      client_time_zone: timeZone,
      client_formatted_time_zone: timeZoneLong,
      lockbox_code: null,
      user_id: null,
      source: TourStatus.SCHEDULED,
      propertyTimezone: this.propertyTimezone,
      landlordId: this.landlordId,
      performerName: this.visitorName,
      performerEmail: this.visitorEmail,
      channel: TourChannel.LINK,
      token: this.token,
    };
    
    this.tourService.scheduleTour(tourPayload).subscribe(
      (response) => {
        this.isConfirmLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Tour is ${TourStatus.SCHEDULED} successfully`,
        });
        
        this.tourCreated = true;
        this.showContent = true;

        // ✅ Enable form again only if needed
        this.scheduleForm.enable();
        this.applyModelUnitState();
        this.isConfirmLoading = false;
      },
      (error) => {
        const errorMessage = error?.error?.message || 'Failed to create tour!';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage,
        });

        this.isConfirmLoading = false;
        this.scheduleForm.enable();
        this.applyModelUnitState();
      }
    ); 
  }

  isFormValid(): boolean {
    console.log('this.scheduleForm.valid', this.scheduleForm.valid)
    return this.scheduleForm.valid;
  }

  loadUnits(): void {
    if (!this.propertyId) return;
    console.log('this.propertyId', this.propertyId)
    this.tourService.getVisibleUnitsByProperty(this.propertyId).subscribe({
      next: (units: any[]) => {
        if (this.isModelUnit) {
          this.unitOptions = [{ label: this.modelUnitLabel, value: this.modelUnitLabel }];
          this.applyModelUnitState();
          return;
        }

        // Transform for PrimeNG dropdown
        this.unitOptions = units.map(u => ({ label: u.unit, value: u.unit }));
      },
      error: (err) => {
        console.error('Failed to fetch units', err);
      }
    });
  }

  goToNextStep() {
    if (this.isModelUnit) {
      this.applyModelUnitState();
    }

    if (!this.isFormValid()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please fill all required fields correctly.'
      });
      return;
    }

    this.selectedDate = this.selectedDate || new Date();
    this.step = 2; // move to calendar / time selection
    this.goToTimeSelection();
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  get showForm() {
    return !this.tourCreated && this.notUsed;
  }

  get showMessage() {
    return this.tourCreated && this.notUsed;
  }

  private applyModelUnitState(): void {
    if (!this.scheduleForm) return;

    if (this.isModelUnit) {
      this.planName = this.modelUnitLabel;
      this.scheduleForm.patchValue({ planName: this.modelUnitLabel }, { emitEvent: false });
      this.scheduleForm.get('planName')?.disable({ emitEvent: false });
      return;
    }

    this.scheduleForm.get('planName')?.enable({ emitEvent: false });
  }
}
